export enum SortBy {
    ByLastRecentlyFiledTo,
    ByJobName,
    ByJobNumber
}